export const commonBar = (colors, yAxisData, seriesData) => {
    seriesData.map((item, index) => {
        seriesData[index] = {
            value: item,
            itemStyle: {
                color: colors[index]
            },
            emphasis: {
                itemStyle: {
                    color: colors[index]
                }
            }
        };
    });
    const baseOption = {
        grid: {
            left: 110,
            top: '8%',
            bottom: '8%',
            right: '10%',
            containLabel: false
        },
        yAxis: [
            {
                axisLabel: {
                    show: true,
                    color: '#a0a3af',
                    fontSize: 12,
                    fontFamily: 'font-medium',
                    align: 'left',
                    margin: 60
                },
                offset: 20,
                data: yAxisData.reverse()
            }
        ],
        series: [
            {
                label: {
                    normal: {
                        show: true,
                        color: '#515666',
                        padding: [0, 0, 0, 10],
                        fontSize: 14,
                        fontFamily: 'font-medium',
                        position: 'right',
                        formatter: function(params) {
                            return Number(params.value).toFixed(0) + '%';
                        }
                    }
                },
                data: seriesData.reverse(),
                type: 'bar'
            }
        ]
    };
    const chartOption = {
        baseOption: baseOption,
        media: [
            {
                query: {
                    maxWidth: 500
                },
                option: {
                    grid: {
                        left: 85,
                        top: 10,
                        bottom: 20,
                        right: '13%'
                    },
                    yAxis: [
                        {
                            offset: 10
                        }
                    ]
                }
            }
        ]
    };
    return chartOption;
};
export const commonPie = (colors, type, seriesData, data, { context } = {}) => {
    let fixed = type === 'race' ? 1 : 0;
    seriesData.map((item, index) => {
        item.label = {
            formatter(params) {
                let label = context
                    ? context.$t(
                        `md-nbr-demographics.${params.name.toLowerCase()}`
                    )
                    : params.name;
                return (
                    '{a|' +
                    Number(params.value).toFixed(fixed) +
                    '%}\n{b|' +
                    label +
                    '}'
                );
            }
        };
        item.itemStyle = {
            color: colors[index]
        };
        item.emphasis = {
            itemStyle: {
                color: colors[index]
            }
        };
    });
    const baseOption = {
        legend: {
            formatter: function(name) {
                let label = context
                    ? context.$t(`md-nbr-demographics.${name.toLowerCase()}`)
                    : name;
                return (
                    '{a|' +
                    label +
                    '}{b|' +
                    Number(data[type + name]).toFixed(fixed) +
                    '%}'
                );
            },
            padding: 0,
            itemGap: 10,
            textStyle: {
                fontSize: 12,
                padding: [0, 0, 0, 5],
                rich: {
                    a: {
                        color: '#a0a3af',
                        width: type === 'race' ? 80 : 100,
                        lineHeight: 20,
                        padding: [0, 0, 0, 0]
                    },
                    b: {
                        color: '#515666',
                        fontSize: 14,
                        fontFamily: 'font-medium',
                        padding: [0, 0, 0, 10],
                        width: type === 'race' ? 60 : 40,
                        lineHeight: 20
                    }
                }
            }
        },
        series: [
            {
                center: ['50%', '32%'],
                radius: ['29%', '43%'],
                data: seriesData
            }
        ]
    };
    const chartOption = {
        baseOption: baseOption,
        media: [
            {
                query: {
                    maxWidth: 375
                },
                option: {
                    legend: {
                        formatter: function(name) {
                            return (
                                '{a|' +
                                name +
                                '}\n{b|' +
                                Number(data[type + name]).toFixed(fixed) +
                                '%}'
                            );
                        },
                        itemGap: 10,
                        left: '10%',
                        textStyle: {
                            rich: {
                                a: {
                                    align: 'left',
                                    width: 138,
                                    padding: [-20, 0, 0, 0]
                                },
                                b: {
                                    align: 'left',
                                    padding: [-20, 0, 0, 0]
                                }
                            }
                        }
                    },
                    series: [
                        {
                            center: ['50%', '31%'],
                            radius: ['37%', '53%']
                        }
                    ]
                }
            },
            {
                query: {
                    maxWidth: 330
                },
                option: {
                    legend: {
                        textStyle: {
                            rich: {
                                a: {
                                    width: 110
                                }
                            }
                        }
                    }
                }
            }
        ]
    };
    return chartOption;
};
